export const IMAGE_WIDTH = 175;
export const IMAGE_HEIGHT = 175;
export const UPLOAD_MESSAGE = "Upload an image of "+IMAGE_WIDTH+"px by "+IMAGE_HEIGHT+"px to display as your ad";
export const UPLOAD_ERROR = "Please upload an image file of "+IMAGE_WIDTH+"px by "+IMAGE_HEIGHT+"px.";
export const ONE_DAY = 24*60*60*1000;

export const SUBMIT_SUCCESS = "Your ad has been successfully uploaded. We will notify you when it is posted to our app.";
export const SUBMIT_ERROR = "There was an error submitting your ad. Please try again or use the chat box at the bottom right for help.";



// WEBPACK FOOTER //
// ./src/views/Ads/constants.js